import React from 'react';
import InfoRoundIcon from '@rsuite/icons/InfoRound';
import { Whisper } from 'rsuite';
import StatusInfoPopover from './status-info-popover';

export const StatusHeaderRenderer = () => {
  return (
    <div className="flex items-center">
      <span>Status</span>
      <Whisper
        placement="bottomEnd"
        trigger="click"
        speaker={(props, ref) => {
          const { className } = props;
          return <StatusInfoPopover className={className} ref={ref} />;
        }}
      >
        <InfoRoundIcon
          data-testid="status-info-popover-trigger"
          className="w-4 h-4 ml-2 cursor-pointer text-blue-500"
        />
      </Whisper>
    </div>
  );
};
